"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportedFantomERC20 = void 0;
exports.supportedFantomERC20 = {
    '0xD3b71117E6C1558c1553305b44988cd944e97300': {
        name: 'YEL Token',
        symbol: 'YEL',
        decimals: 18,
    },
};
